export class PriVariableDetailEntity{
    id:number;
    variableId:number;
    value: string;

    constructor(){}
}